(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sku-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('input[data-sgs-rotate]').forEach(function (input) {
      var words = input.getAttribute('data-sgs-rotate').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var prefix = input.getAttribute('data-sgs-prefix') || '';
      if (!words.length) return;
      if (reduce) { input.placeholder = prefix + words[0]; return; }
      var wi = 0, ci = 0, deleting = false;
      function tick() {
        if (document.activeElement === input || input.value) { setTimeout(tick, 1200); return; }
        var word = words[wi];
        ci = deleting ? ci - 1 : ci + 1;
        input.placeholder = prefix + word.slice(0, ci) + (deleting ? '' : '|');
        var wait = 70;
        if (!deleting && ci === word.length) { wait = 1600; deleting = true; }
        else if (deleting && ci === 0) { deleting = false; wi = (wi + 1) % words.length; wait = 300; }
        setTimeout(tick, wait);
      }
      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
